module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_5010.a00dd383.png";